import { ServiceFetch } from '../service-fetch'

export default class PointExchangeModel extends ServiceFetch {
    generatePointExchangeLastCode = (data) => this.authFetch({
        url: 'point-exchange/generatePointExchangeLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getPointExchangeBy = (data) => this.authFetch({
        url: 'point-exchange/getPointExchangeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getPointExchangeByCode = (data) => this.authFetch({
        url: 'point-exchange/getPointExchangeByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    checkDuplicate = (data) => this.authFetch({
        url: 'point-exchange/checkDuplicate',
        method: 'POST',
        body: JSON.stringify(data),
    })

    approvePointExchangeBy = (data) => this.authFetch({
        url: 'point-exchange/approvePointExchangeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertPointExchange = (data) => this.authFetch({
        url: 'point-exchange/insertPointExchange',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updatePointExchangeBy = (data) => this.authFetch({
        url: 'point-exchange/updatePointExchangeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deletePointExchangeByCode = (data) => this.authFetch({
        url: 'point-exchange/deletePointExchangeByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
